// opervex-frontend/src/Opervex/MaterialManagement/Categories.js

class Categories {
  #_api;

  constructor(api) {
    this.#_api = api;
  }

  async findId(id) {
    return this.#_api.get("/MaterialManagement/Categories/" + id);
  }

  async findAll() {
    return this.#_api.get("/MaterialManagement/Categories");
  }

  async update(id, data) {
    return this.#_api.put("/MaterialManagement/Categories/" + id, data);
  }

  async create(data) {
    return this.#_api.post("/MaterialManagement/Categories/", data);
  }

  async schema() {
    return [
      {
        key: "id",
        label: "Código",
        type: "number",
        visible: true,
        hidden: false,
      },
      {
        key: "description",
        label: "Descrição",
        type: "string",
        visible: true,
        hidden: false,
      },
      {
        key: "subcategory",
        label: "Subcategoria",
        type: "boolean",
        visible: true,
        hidden: false,
      },
      {
        key: "disabled",
        label: "Inatívo",
        type: "boolean",
        visible: true,
        hidden: false,
      },
    ];
  }
}

// Export the class itself (not an instance)
export default Categories;
